import styled from "styled-components";

export const CompaniesWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& select, & input": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },
    "& .heading-row": {
      margin: 0,
      "& span": {
        fontFamily: "Poppins",
        fontWeight: 700,
        fontSize: "1.2rem",
        color: "var(--color-text)",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
      },
    },
    "& .filter": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: "0.9rem",
      alignItems: "end",
      marginBlockEnd: 0,
      "@media screen and (max-width: 1024px)": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      "@media screen and (max-width: 640px)": {
        gridTemplateColumns: "1fr",
        padding: "0.75rem",
      },
    },
    "& .admin-table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
    },
    "& .admin-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& .admin-table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .admin-table td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },
    "& .admin-table td:last-child": {
      color: "var(--color-text)",
      "&:hover": {
        color: "var(--color-primary)",
        textDecoration: "underline",
        cursor: "pointer",
      },
    },
    "& .table-footer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      borderTop: "1px solid #edf1f6",
      backgroundColor: "var(--color-neutral)",
      fontSize: "0.88rem",
      color: "var(--color-text)",
    },
    "& .pagination": {
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
    },
    "& .page-chip": {
      padding: "0.5rem 0.75rem",
      border: "1px solid #d9dee7",
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
      borderRadius: "0.45rem",
      cursor: "pointer",
      fontSize: "0.85rem",
      fontWeight: 600,
      transition: "all 0.2s ease",
      "&:hover:not(:disabled):not(.active)": {
        backgroundColor: "var(--color-primary-hover)",
        borderColor: "var(--color-primary)",
      },
      "&.active": {
        backgroundColor: "var(--color-primary)",
        color: "white",
        borderColor: "var(--color-primary)",
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
  };
});
